import React from 'react';

function StoryTabs({ tabs, selectedtab, setSelectedTab }) {
  return (
    <div style={{ display: 'flex' }}>
      {tabs.map((item, index) => {
        const isSelected = selectedtab === item.value;
        return (
          <div
            onClick={() => {
              setSelectedTab(item.value);
            }}
            key={item.value}
            style={{ cursor: 'pointer', marginLeft: index ? 40 : 0 }}
          >
            <h4
              style={{
                color: isSelected ? '#0B335E' : 'grey',
              }}
            >
              {item.title}
            </h4>
            {isSelected && (
              <div
                style={{
                  backgroundColor: '#0B335E',
                  height: 2.5,
                  width: '100%',
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}

export default StoryTabs;
